// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticlePublishDate_wrapper__R2Gsj","wrapper__textOnly":"ArticlePublishDate_wrapper__textOnly__jQmRo","calendarIcon":"ArticlePublishDate_calendarIcon__PGcIE"};